import React from 'react'
import { Value } from '../../elements'
import { formatPhoneNumber } from '../../../../lib/utils/helpers'

export const getMobileFields = () => [
  {
    key: 'name',
    label: 'ФИО',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'phone',
    label: 'Телефон',
    render: (val) => formatPhoneNumber(val),
  },
  {
    key: 'email',
    label: 'E-mail',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'office_name',
    label: 'Офис',
    render: (val) => <Value data={val} />,
  },
]

